import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  login: false,
  error: {
    show: false,
    message: "",
  },
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = {
        show: action.payload.show,
        message: action.payload.message,
      };
    },
    setLogin(state, action) {
      // Accepts a boolean; defaults to true when called with no payload.
      state.login = action.payload ?? true;
    },
  },
});

export const { setLoading, setError, setLogin } = uiSlice.actions;
export default uiSlice.reducer;
